import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { initSentry, setupSentryConsent, Sentry } from './lib/sentry';
import { setupMetrika } from './lib/metrika';
// Onest: единственный шрифт сайта (UI и заголовки), локально из npm.
import '@fontsource-variable/onest';
import './styles/index.css';

initSentry();
setupSentryConsent();
setupMetrika();

const container = document.getElementById('root')!;
const app = (
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<CrashFallback />}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// В проде HTML страницы пререндерен (scripts/prerender.mjs), оживляем готовую
// разметку. В dev и на страницах без пререндера (/login, /signup, /cabinet)
// корень пуст, обычный клиентский рендер.
if (container.firstElementChild) {
  ReactDOM.hydrateRoot(container, app, {
    onRecoverableError: (error, info) => {
      // Расхождение сервер/клиент React чинит сам, но это сигнал о баге -
      // видим его в консоли и в Sentry.
      console.error(error, info.componentStack);
      Sentry.captureException(error, { tags: { phase: 'hydration' } });
    },
  });
} else {
  ReactDOM.createRoot(container).render(app);
}

function CrashFallback() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: '#F7F5F0',
        color: '#0E1747',
        fontFamily: "'Onest Variable', Onest, system-ui, sans-serif",
        padding: 24,
      }}
    >
      <div style={{ maxWidth: 460, textAlign: 'center' }}>
        <div
          style={{
            fontSize: 11,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            opacity: 0.55,
            marginBottom: 12,
          }}
        >
          Что-то сломалось
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 500, margin: 0, letterSpacing: '-0.02em' }}>
          Мы уже знаем об ошибке
        </h1>
        <p style={{ marginTop: 16, fontSize: 15, lineHeight: 1.6, opacity: 0.75 }}>
          Попробуйте перезагрузить страницу. Если не поможет, напишите нам на{' '}
          <a href="mailto:resstrosaas@mail.ru" style={{ color: '#0E1747' }}>
            resstrosaas@mail.ru
          </a>
          .
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            marginTop: 24,
            padding: '13px 24px',
            background: '#E85624',
            color: '#FFFFFF',
            border: 0,
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          Перезагрузить
        </button>
      </div>
    </div>
  );
}
